import React, { memo, useEffect, useMemo, useRef, } from 'react';
import LinearGradient from 'utils/packages/linearGradient';
import { useRoute } from '@react-navigation/native';
import { View, StyleSheet, ScrollView } from 'react-native';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { noop } from 'lodash';
import TimePeriod from './TimePeriod';
import AnimatedMarker from './AnimatedMarker';
import TimeFrameController from './TimeFrameController';
const cardPadding = rem(32);
const gradientEnd = { x: 1, y: 1 };
const gradientStart = { x: 0, y: 1 };
const viewPadding = rem(16 * 2 + 6 * 2);
const timePeriodWidth = rem(10 * 2 + 36);
const ScrollableTimeFrameController = ({ periods, scrollToEnd, strokeColor, minusWidth = 0, selectedPeriod, paddingHorizontal, setSelectedPeriod, darkActiveIndicator, }) => {
    const route = useRoute();
    const isInTab = route.name === 'NetworthTab';
    const colors = useColors();
    const { width } = useAppFrameDimensions(isInTab);
    const scrollViewRef = useRef(null);
    const requiredWidth = periods.length * timePeriodWidth;
    const gradientColors = useMemo(() => ({
        leftGradient: [
            colors.cards.onDark,
            //@ts-ignore
            `${colors.cards.onDark}00`,
        ],
        rightGradient: [
            //@ts-ignore
            `${colors.cards.onDark}00`,
            colors.cards.onDark,
        ],
    }), [colors.cards.onDark]);
    useEffect(() => {
        if (scrollToEnd) {
            const timeout = setTimeout(() => {
                scrollViewRef.current?.scrollToEnd();
            }, 100);
            return () => {
                clearTimeout(timeout);
            };
        }
        return noop;
    }, [scrollToEnd]);
    if (requiredWidth + viewPadding <= width - minusWidth - cardPadding) {
        const viewWidth = (width - minusWidth - cardPadding) / periods.length;
        return (<TimeFrameController periods={periods} viewWidth={viewWidth} strokeColor={strokeColor} selectedPeriod={selectedPeriod} paddingHorizontal={paddingHorizontal} setSelectedPeriod={setSelectedPeriod} darkActiveIndicator={darkActiveIndicator}/>);
    }
    return (<View>
      <ScrollView horizontal ref={scrollViewRef} showsHorizontalScrollIndicator={false} contentContainerStyle={styles.contentContainer}>
        <Spacer w={4}/>
        <View style={[styles.container, { width: requiredWidth }]}>
          <AnimatedMarker periods={periods} viewWidth={timePeriodWidth} backgroundColor={strokeColor} selectedPeriod={selectedPeriod} paddingHorizontal={paddingHorizontal}/>
          {periods.map((period) => (<View style={styles.flex} key={period}>
              <TimePeriod period={period} periods={periods} viewWidth={timePeriodWidth} scrollViewRef={scrollViewRef} selectedPeriod={selectedPeriod} setSelectedPeriod={setSelectedPeriod} darkActiveIndicator={darkActiveIndicator}/>
            </View>))}
        </View>
        <Spacer w={4}/>
      </ScrollView>
      <View style={styles.leftGradient}>
        <LinearGradient end={gradientEnd} start={gradientStart} style={styles.gradientView} colors={gradientColors.leftGradient}/>
      </View>
      <View style={styles.rightGradient}>
        <LinearGradient end={gradientEnd} start={gradientStart} style={styles.gradientView} colors={gradientColors.rightGradient}/>
      </View>
    </View>);
};
export default memo(ScrollableTimeFrameController);
const styles = StyleSheet.create({
    flex: {
        flex: 1,
        alignItems: 'center',
    },
    gradientView: {
        flex: 1,
    },
    container: {
        flexDirection: 'row',
    },
    leftGradient: {
        left: 0,
        top: rem(16),
        width: rem(16),
        bottom: rem(16),
        position: 'absolute',
    },
    rightGradient: {
        right: 0,
        top: rem(16),
        width: rem(16),
        bottom: rem(16),
        position: 'absolute',
    },
    contentContainer: {
        paddingHorizontal: rem(6),
    },
});
